
let Formats = {}

Formats['plain_text'] = require('./v1/TextPlainFormat').createTextPlainOrderInvoice
Formats['html'] = require('./v2/HTMLFormat').createHTMLOrderInvoice
Formats['html_v1'] = require('./v1/HTMLFormat').createHTMLOrderInvoice

export default Formats;

